import React, { Component } from "react";
import { Segment, Header, List, Divider,Button } from "semantic-ui-react";
import moment from "moment";

const DATE_FIELDS = new Set([
  "inspection_start_time",
  "inspection_end_time",
  "created_at",
  "updated_at",
]);


const formatValue = (field, val) => {
  if (val === null || val === undefined) return "";

  if (DATE_FIELDS.has(field)) {
    return moment(val).format("DD-MM-YYYY HH:mm");
  }

  return typeof val === "object" ? JSON.stringify(val) : String(val);
};
const formatFieldName = (field) => {
  if (!field) return "";

  return field
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

class ChangeHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedEntries: {},
    };
  }

  togglePreviousState(index) {
    this.setState((prev) => ({
      expandedEntries: {
        ...prev.expandedEntries,
        [index]: !prev.expandedEntries[index],
      },
    }));
  }

  renderChangeItem(field, change) {
    const formatValue = (val) => {
      if (val === null || val === undefined) return "";

      if (DATE_FIELDS.has(field)) {
        return moment(val).format("DD-MM-YYYY HH:mm");
      }

      return String(val);
    };

    return (
      <List.Item key={field}>
        <strong>{formatFieldName(field)}</strong>:{" "}
        <span style={{ color: "#999" }}>
          {formatValue(change.from)}
        </span>
        {" → "}
        <span style={{ color: "#21ba45" }}>
          {formatValue(change.to)}
        </span>
      </List.Item>
    );
  }

renderPreviousState(previousState) {
  if (!previousState) return null;

  return (
    <div style={{ marginTop: "10px" }}>
      <Divider />
      <Header color="red" as="h3">Previous State</Header>

      <List>
        {Object.entries(previousState).map(([key, value]) => (
          <List.Item key={key}>
            <strong>{formatFieldName(key)}</strong>:{" "}
            <span style={{ color: "#666" }}>
              {formatValue(key, value)}
            </span>
          </List.Item>
        ))}
      </List>
    </div>
  );
}

  renderEntry(entry, index) {
    const { changed_at, changed_by, changes, previous_state } = entry;

    const isExpanded = this.state.expandedEntries[index];

    return (
      <Segment key={index}>
        <Header as="h5">
          <Button compact color="red" basic>{changed_by || "Unknown user"}{" "}</Button>
          <span style={{ fontWeight: 400, color: "#888" }}>
            ·{" "}
            {changed_at
              ? moment(changed_at).format("DD-MM-YYYY HH:mm")
              : ""}
          </span>
        </Header>

        <List>
          {changes &&
            Object.entries(changes).map(([field, change]) =>
              this.renderChangeItem(field, change)
            )}
        </List>

        <div
          onClick={() => this.togglePreviousState(index)}
          style={{
            cursor: "pointer",
            color: "#2185d0",
            marginTop: "10px",
            fontSize: "0.9em",
            userSelect: "none",
          }}
        >
          {isExpanded ? "Hide Previous State" : "View Previous State"}
        </div>

        {isExpanded && this.renderPreviousState(previous_state)}
      </Segment>
    );
  }

  render() {
    const { changeHistory } = this.props;

    if (!changeHistory || changeHistory.length === 0) {
      return <Segment>No change history available</Segment>;
    }

    return (
      <Segment>
        {changeHistory
          .slice()
          .reverse()
          .map((entry, index) => this.renderEntry(entry, index))}
      </Segment>
    );
  }
}

export default ChangeHistory;


// WEBPACK FOOTER //
// ./src/views/inspection/change_history.js